import { styled } from "../theme";
import { Text } from "./Text";
export const H1 = styled(Text) ``;
H1.defaultProps = {
    as: "h1",
    fontSize: [5, 6],
    marginTop: [3, 4],
    marginBottom: "1em",
    fontWeight: "bold",
};
export const H2 = styled(Text) `
  margin-top: 1em;
  margin-bottom: 0.5em;
`;
H2.defaultProps = {
    as: "h2",
    fontSize: [4, 5],
    fontWeight: "bold",
};
export const H3 = styled(Text) `
  margin-top: 0.5em;
  margin-bottom: 0.4em;
`;
H3.defaultProps = {
    as: "h3",
    fontSize: [3],
    fontWeight: "bold",
};
export const H4 = styled(Text) `
  margin-top: 10px;
  margin-bottom: 9px;
`;
H4.defaultProps = {
    as: "h4",
    fontSize: [3],
    fontWeight: "bold",
};
export const H5 = styled(Text) `
  margin-top: 9px;
  margin-bottom: 6px;
`;
H5.defaultProps = {
    as: "h5",
    fontSize: [2],
    fontWeight: "medium",
};
export const Caption = styled(Text) `
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  color: ${({ theme }) => theme.color.darkBlue40};
`;
Caption.defaultProps = {
    as: "div",
    fontSize: [1],
    fontWeight: "medium",
};
export const Paragraph = styled(Text) `
  margin-top: 0.5em;
  margin-bottom: 0.75em;

  small {
    display: inline-block;
    line-height: 1.4em;
    font-size: 0.6em;
  }
`;
Paragraph.defaultProps = {
    as: "p",
    lineHeight: "1.8em",
};
